import { render } from "./creditclassic.vue?vue&type=template&id=41da781e&bindings={\"navigate\":\"props\"}"
import script from "./creditclassic.vue?vue&type=script&lang=js"
export * from "./creditclassic.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./creditclassic.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script